import { type MetaFunction } from '@remix-run/node'
import { LegalPageLayout } from '#app/components/legal/LegalPageLayout.tsx'

export const meta: MetaFunction = () => [
	{ title: 'Aviso legal | Asociación Síndrome PCDH19' },
]

export default function AvisoLegalRoute() {
	return (
		<LegalPageLayout
			title="Aviso legal"
			intro="ASOCIACIÓN SINDROME PCDH19, responsable del sitio web, pone a disposición de los usuarios el presente documento para dar cumplimiento a la Ley 34/2002 (LSSICE) e informar de las condiciones de uso."
		>
			<h2>LEY DE LOS SERVICIOS DE LA SOCIEDAD DE LA INFORMACIÓN (LSSI)</h2>
			<p>
				Toda persona que acceda a este sitio web asume el papel de usuario,
				comprometiéndose a la observancia y cumplimiento riguroso de las
				disposiciones aquí dispuestas, así como a cualquier otra disposición legal
				que fuera de aplicación.
			</p>
			<p>
				ASOCIACIÓN SINDROME PCDH19 se reserva el derecho de modificar cualquier
				tipo de información que pudiera aparecer en el sitio web, sin que exista
				obligación de preavisar o poner en conocimiento de los usuarios dichas
				obligaciones, entendiéndose como suficiente la publicación en el sitio web.
			</p>

			<h2>1. DATOS IDENTIFICATIVOS</h2>
			<ul>
				<li>
					<strong>Nombre de dominio:</strong> www.pcdh19.com/
				</li>
				<li>
					<strong>Nombre comercial:</strong> Asociación Síndrome PCDH19
				</li>
				<li>
					<strong>Denominación social:</strong> ASOCIACIÓN SINDROME PCDH19
				</li>
				<li>
					<strong>NIF:</strong> G93340255
				</li>
				<li>
					<strong>Domicilio social:</strong> Calle Violin 27, 29620, Málaga
				</li>
				<li>
					<strong>Teléfono:</strong> 657274067
				</li>
				<li>
					<strong>E-mail:</strong> asociacionpcdh19@gmail.com
				</li>
			</ul>

			<h2>2. DERECHOS DE PROPIEDAD INTELECTUAL E INDUSTRIAL</h2>
			<p>
				El sitio web, incluyendo a título enunciativo pero no limitativo su
				programación, edición, compilación y demás elementos necesarios para su
				funcionamiento, los diseños, logotipos, texto y/o gráficos, son propiedad
				del RESPONSABLE o, si es el caso, dispone de licencia o autorización
				expresa por parte de los autores.
			</p>
			<p>
				Todos los contenidos del sitio web se encuentran debidamente protegidos por
				la normativa de propiedad intelectual e industrial, así como inscritos en
				los registros públicos correspondientes. Cualquier uso no autorizado
				previamente se considera un incumplimiento grave de los derechos de
				propiedad intelectual o industrial del autor.
			</p>
			<p>
				Los diseños, logotipos, texto y/o gráficos ajenos al RESPONSABLE y que
				pudieran aparecer en el sitio web, pertenecen a sus respectivos
				propietarios, siendo ellos mismos responsables de cualquier posible
				controversia que pudiera suscitarse respecto a los mismos.
			</p>
			<p>
				Para realizar cualquier tipo de observación respecto a posibles
				incumplimientos de los derechos de propiedad intelectual o industrial,
				así como sobre cualquiera de los contenidos del sitio web, puede hacerlo a
				través del correo electrónico
				<strong> asociacionpcdh19@gmail.com</strong>.
			</p>

			<h2>3. EXENCIÓN DE RESPONSABILIDADES</h2>
			<p>
				El RESPONSABLE se exime de cualquier tipo de responsabilidad derivada de la
				información publicada en su sitio web siempre que no tenga conocimiento
				efectivo de que esta información haya sido manipulada o introducida por un
				tercero ajeno al mismo o, si lo tiene, haya actuado con diligencia para
				retirar los datos o hacer imposible el acceso a ellos.
			</p>
			<h3>Uso de cookies</h3>
			<p>
				Este sitio web puede utilizar cookies técnicas para llevar a cabo
				determinadas funciones imprescindibles para el correcto funcionamiento y
				visualización del sitio. Este sitio web no instalará cookies prescindibles
				sin el consentimiento previo del usuario.
			</p>
			<h3>Política de enlaces</h3>
			<p>
				Desde el sitio web, es posible que se redirija a contenidos de terceros
				sitios web. Dado que el RESPONSABLE no puede controlar siempre los
				contenidos introducidos por terceros en sus respectivos sitios web, no
				asume ningún tipo de responsabilidad respecto a dichos contenidos.
			</p>
			<p>
				En todo caso, procederá a la retirada inmediata de cualquier contenido que
				pudiera contravenir la legislación nacional o internacional, la moral o el
				orden público.
			</p>
			<h3>Direcciones IP</h3>
			<p>
				Los servidores del sitio web podrán detectar de manera automática la
				dirección IP y el nombre de dominio utilizados por el usuario para obtener
				mediciones únicamente estadísticas (número de impresiones de páginas,
				número de visitas, orden de visitas y punto de acceso).
			</p>

			<h2>4. LEY APLICABLE Y JURISDICCIÓN</h2>
			<p>
				Para la resolución de todas las controversias o cuestiones relacionadas con
				el presente sitio web o de las actividades en él desarrolladas, será de
				aplicación la legislación española. Serán competentes los Juzgados y
				Tribunales del domicilio del USUARIO o el lugar del cumplimiento de la
				obligación.
			</p>
		</LegalPageLayout>
	)
}
